/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.ts` */
/* eslint-disable */
// noinspection JSUnusedGlobalSymbols, DuplicatedCode

import * as Types from '__generated__/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetSailingSchedulesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSailingSchedulesQuery = {
  __typename?: 'Query',
  sailingSchedules: Array<{
    __typename?: 'SailingSchedule',
    id: number,
    schedule: string
  }>
};


export const GetSailingSchedulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSailingSchedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sailingSchedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"schedule"}}]}}]}}]} as unknown as DocumentNode<GetSailingSchedulesQuery, GetSailingSchedulesQueryVariables>;